import React from 'react';
import { useTheme } from '@mui/material/styles';
import { SvgIconComponent } from '@mui/icons-material';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { ThemeProps } from '@styles/theme';
import { messages } from 'Download/download.messages';
import { useStyles } from './DocumentationLinks.styles';

type DocLink = {
    id: string,
    title: string,
    description: string,
    url: string,
    Icon: SvgIconComponent,
};

const DOCS: DocLink[] = [
    {
        id: 'landing',
        title: messages['downloadPage.documentation.landing.title'],
        description: messages['downloadPage.documentation.landing.description'],
        url: 'https://docs.xr-weavr.com',
        Icon: MenuBookOutlinedIcon,
    },
    {
        id: 'creator',
        title: messages['downloadPage.documentation.creator.title'],
        description: messages['downloadPage.documentation.creator.description'],
        url: 'https://docs.xr-weavr.com/docs/creator',
        Icon: DesignServicesOutlinedIcon,
    },
    {
        id: 'manager',
        title: messages['downloadPage.documentation.manager.title'],
        description: messages['downloadPage.documentation.manager.description'],
        url: 'https://docs.xr-weavr.com/docs/manager',
        Icon: GroupsOutlinedIcon,
    },
    {
        id: 'player',
        title: messages['downloadPage.documentation.player.title'],
        description: messages['downloadPage.documentation.player.description'],
        url: 'https://docs.xr-weavr.com/docs/player',
        Icon: PlayCircleOutlineOutlinedIcon,
    },
];

export const DocumentationLinks: React.FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    return (
        <div className={styles.wrapper}>
            <h4 className={styles.title}>{messages['downloadPage.documentation.title']}</h4>
            <p className={styles.subtitle}>{messages['downloadPage.documentation.subtitle']}</p>

            <div className={styles.grid}>
                {DOCS.map(({ id, title, description, url, Icon }) => (
                    <a
                        key={id}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.card}
                        data-testid={`documentation-link-${id}`}
                    >
                        <OpenInNewIcon className={styles.externalIcon} />
                        <Icon className={styles.icon} />
                        <p className={styles.cardTitle}>{title}</p>
                        <p className={styles.cardDescription}>{description}</p>
                    </a>
                ))}
            </div>
        </div>
    );
};

DocumentationLinks.displayName = 'DocumentationLinks';
